/** 공개 랜딩·문의 페이지 공통: 문의 유형별 메타 */
export const inquiryTypeMeta = {
  TEAM: {
    label: 'GA·원수사 단체 도입이 궁금해요',
    helper: '몇 분이 쓰실지, 어떤 방식으로 운영하고 싶은지, 데모가 필요한지 적어 주시면 답변이 빨라져요.',
    companyPlaceholder: 'GA명, 법인명, 지점명 등',
    messagePlaceholder: '예: 직원 20명 정도 쓰게 하고 싶어요. 의뢰·배정이 어떻게 돌아가는지 보고 싶습니다.',
  },
  PERSONAL: {
    label: '개인 설계사로 써보고 싶어요',
    helper: '가입 방법이나 앱·웹 중 어디부터 쓰면 좋을지 궁금하면 편하게 적어 주세요.',
    companyPlaceholder: '소속이 있으면 적어 주세요. 없으면 비워 두셔도 돼요.',
    messagePlaceholder: '예: 혼자 써도 되는지, 가입 후 바로 쓸 수 있는 기능이 뭔지 알고 싶어요.',
  },
}
